import { MantineThemeOverride, rem } from '@mantine/core';
import { P1Regular, P2Regular, P3Regular } from 'theme/typography';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';

export type SelectTheme = NonNullable<MantineThemeOverride['components']>['Select'];

export const Select: SelectTheme = {
  defaultProps: (theme) => ({
    size: 'md',
    withinPortal: true,
    maxDropdownHeight: 400,
    searchable: true,
  }),
  styles: (theme) => ({
    input: {
      borderColor: theme.colors.gray[4],
      background: theme.white,
      boxShadow: 'none !important',
      '&:hover:not(:disabled):not([readonly])': {
        borderColor: theme.colors.red[8],
      },
      '&:focus': {
        borderColor: theme.colors.red[8],
        color: theme.colors.gray[8],
      },
      '&:disabled': {
        color: theme.colors.gray[4],
        backgroundColor: theme.colors.gray[1],
      },
      '&[readonly]': {
        color: theme.colors.gray[6],
        backgroundColor: theme.colors.gray[1],
        cursor: 'not-allowed',
      },
      '&:filled': {
        color: theme.colors.gray[8],
      },
    },
    dropdown: {
      '&:hover': {
        Color: theme.colors.red[8],
      },
    },
    label: {
      color: theme.colors.gray[6],
      '&:disabled': {
        color: theme.colors.gray[2],
      },
    },
    item: {
      whiteSpace: 'pre-wrap',
    },
    rightSection: {
      '& button': {
        paddingLeft: '0',
        paddingRight: '0',
        opacity: 0.7,
        marginRight: rem(-12),
        transition: 'opacity 100ms ease',
        '&:hover': {
          opacity: 1,
        },
        '& svg': {
          width: `${rem(16)} !important`,
          height: `${rem(16)} !important`,
        },
      },
    },
  }),
  sizes: {
    lg: (theme) => ({
      input: {
        paddingLeft: rem(16),
        paddingRight: rem(16),
        paddingTop: rem(12),
        paddingBottom: rem(12),
        height: rem(48),
        minHeight: rem(48),
        ...P1Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          paddingLeft: rem(12),
          paddingRight: rem(12),
          paddingTop: rem(8),
          paddingBottom: rem(8),
          height: rem(40),
          minHeight: rem(40),
        },
      },
      dropdown: {
        ...P1Regular,
      },
      item: {
        ...P1Regular,
      },
      label: {
        ...P2Regular,
      },
    }),
    md: (theme) => ({
      input: {
        paddingLeft: rem(12),
        paddingRight: rem(12),
        paddingTop: rem(8),
        paddingBottom: rem(8),
        height: rem(40),
        minHeight: rem(40),
        ...P1Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          paddingLeft: rem(8),
          paddingRight: rem(8),
          paddingTop: rem(4),
          paddingBottom: rem(4),
          height: rem(32),
          minHeight: rem(32),
          ...P2Regular,
        },
      },
      dropdown: {
        ...P1Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P2Regular,
        },
      },
      item: {
        ...P1Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P2Regular,
        },
      },
      label: {
        ...P2Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P3Regular,
        },
      },
    }),
    sm: (theme) => ({
      input: {
        paddingLeft: rem(8),
        paddingRight: rem(8),
        paddingTop: rem(4),
        paddingBottom: rem(4),
        height: rem(32),
        minHeight: rem(32),
        ...P2Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          paddingLeft: rem(6),
          paddingRight: rem(6),
          paddingTop: rem(2),
          paddingBottom: rem(2),
          height: rem(28),
          minHeight: rem(28),
          ...P3Regular,
        },
      },
      dropdown: {
        ...P2Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P3Regular,
        },
      },
      item: {
        ...P2Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P3Regular,
        },
      },
      label: {
        ...P3Regular,
      },
    }),
  },
};
